import { render, staticRenderFns } from "./MyofficialratingandCertification.vue?vue&type=template&id=fc5762c4"
import script from "./MyofficialratingandCertification.vue?vue&type=script&lang=js"
export * from "./MyofficialratingandCertification.vue?vue&type=script&lang=js"
import style0 from "./MyofficialratingandCertification.vue?vue&type=style&index=0&id=fc5762c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports